import React,{useState,}from 'react'
import { Modal,Form, Button,message, Input,} from 'antd';
import MyEditor from '../../cpn/MyEditor';
import RequireDesc from './RequireDesc';
import { useBnsXuQiuAddMutation } from '../../store/BnsKeJiApi';
import Main from '../../cpn/Main';
import ModuleSelect from '../../backend/module/ModuleSelect';
function RequireAdd() {    
    const [form] = Form.useForm();
    const [info,setInfo] = useState()
    const [add] = useBnsXuQiuAddMutation()
    //返回详情
    const [openCheck, setopenCheck] = useState({id:'',open:false})
    return (
        <Main selectedKeys={['/RequireAdd']} >
            <Form
                form={form}
                layout="horizonal"
                name="form_client_add"
                initialValues={{modifier: 'public',}}
                labelCol={{ span: 3 }}
                onFinish={() => {
                    add({
                        "bxq_cid" : localStorage.getItem('eu_id'),
                        "bxq_cname" : localStorage.getItem('eu_name'),
                        "bxq_content" : info.bxq_content,
                        "bxq_dept_id" : info.bxq_dept_id,
                        "bxq_dept_name" : info.bxq_dept_name,
                        "bxq_bg_id" : info.bxq_bg_id,
                        "bxq_bg_name" : info.bxq_bg_name,
                        "bxq_bgn_id" : info.bxq_bgn_id,
                        "bxq_bgn_name" : info.bxq_bgn_name,
                        "bxq_e_id" : localStorage.getItem('e_id'),
                        "bxq_name" : info.bxq_name,
                    }).then((res) => {
                        if (res.data.Status === 'success') {
                            message.info('新增成功！');
                            setopenCheck({id:res.data.Result,open:true})    
                        }
                        if (res.data.Status === "fail") {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })                           
                }}
            >                        
                <ModuleSelect
                    label='版本'
                    required
                    onChangeProduct={(e,f,g,h) => {
                        setInfo(prevState=>({
                            ...prevState,
                            bxq_bg_id:e,
                            bxq_bg_name:f,
                            "bxq_dept_id" : g,
                            "bxq_dept_name" : h,
                        }))
                    }}
                    onChangeVersion={(e,f) => {
                        setInfo(prevState=>({
                            ...prevState,
                            bxq_bgn_id:e,
                            bxq_bgn_name:f.label
                        }))
                    }}
                />  
                <Form.Item 
                    name="title" 
                    label='标题' 
                    wrapperCol={{span:20}} 
                    required
                >
                    <Input 
                        onChange={(e) => {setInfo(prevState=>({...prevState,bxq_name:e.target.value}))}}
                    />
                </Form.Item> 
                <Form.Item 
                    name="doc" 
                    label='正文' 
                    wrapperCol={{span:20}} 
                >
                    <MyEditor 
                        onChange={(e) => {setInfo(prevState=>({...prevState,bxq_content:e}))}}
                    />
                </Form.Item> 
                <Form.Item wrapperCol={{offset:3}} >                        
                    <Button type='primary' htmlType='submit'>提交</Button>
                </Form.Item>
            </Form>
            <Modal 
                open={openCheck.open} 
                onOk={() => {}} 
                onCancel={() => {setopenCheck({open:false})}}
                width={1200}
                cancelText='关闭'
                footer={(_, { OkBtn, CancelBtn }) => (
                    <>
                        <Button
                            onClick={() => {
                                setopenCheck(false);
                            }}
                        >再增一条</Button>
                        <CancelBtn />
                    </>
                )}
            >
                <RequireDesc
                    bxq_id={openCheck.id}
                />
            </Modal> 
        </Main>
    )
}

export default RequireAdd